import React, { useState, useEffect } from 'react';
import SolicitudEmpleoCard from 'components/Cards/SolicitudEmpleoCard';
import ToggleDetail from 'components/ToggleDetail';
import JobAppliedInformationFormWrapper from 'components/Forms/JobAppliedInformationFormWrapper';
import { connect } from 'react-redux';
import { SetLoading } from "redux/actions/loadingActions";
import { get } from 'services';
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner'
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const JobAppliedInformationModule = ({ user }) => {
  const [showDetail, setShowDetail] = useState(true);
  const [puesto, setPuesto] = useState("");
  const [tipoContrato, setTipoContrato] = useState("");
  const [disponibilidadEntrada, setDisponibilidadEntrada] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true)

        if (!hasSolicitudEmpleo() || (user.persona.solicitudEmpleo[0].solicitudesHorario.length == 0 || user.persona.solicitudEmpleo[0].solicitudEmpleoEmpleado.length == 0)) {
          let solicitudEmpleo = await get(`SolicitudEmpleo/GetByPersonaId/${user.persona.id}`);
          if (solicitudEmpleo.data.length > 0) {
            const solicitudesHorarioDB = await get(`SolicitudHorarioTipo?$filter=SolicitudEmpleoId eq ${solicitudEmpleo.data[0]?.id}`)
            const solicitudEmpleoEmpleadoDB = await get(`SolicitudEmpleoEmpleado/GetByPersonaId/${solicitudEmpleo.data[0]?.id}`);
            solicitudEmpleo.data[0].solicitudesHorario = solicitudesHorarioDB.data
            solicitudEmpleo.data[0].solicitudEmpleoEmpleado = solicitudEmpleoEmpleadoDB.data
            user.persona.solicitudEmpleo = solicitudEmpleo.data;
          }
        }

        if (user.persona.solicitudEmpleo && user.persona.solicitudEmpleo.length > 0 && user.persona.solicitudEmpleo.filter(x => x.estado != 0).length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }


        if (hasSolicitudEmpleo()) {
          const puestoName = await get(`PuestoCategoria?$filter=Id eq ${user.persona.solicitudEmpleo[0].puestoCategoriaId}`);
          const tipoContratoName = await get(`ContratoTipo?$filter=Id eq ${user.persona.solicitudEmpleo[0].contratoTipoId}`);
          const disponibilidadEntradaName = await get(`DisponibilidadEntrada?$filter=Id eq ${user.persona.solicitudEmpleo[0].disponibilidadEntradaId}`);
          if (puestoName.data[0]) {
            setPuesto(puestoName.data[0].nombre)
          }
          if (tipoContratoName.data[0]) {
            setTipoContrato(tipoContratoName.data[0].nombre)
          }
          if (disponibilidadEntradaName.data[0]) {
            setDisponibilidadEntrada(disponibilidadEntradaName.data[0].nombre)
          }
        }

      } catch (error) {
        console.log(error)
        Alerts.operationFail()
      } finally {
        setIsLoading(false)
      }
    })();
    return function cleanup() {
      setPuesto("");
      setTipoContrato("");
      setDisponibilidadEntrada("");
    };
  }, [])

  const hasSolicitudEmpleo = () => {
    return (user.persona.solicitudEmpleo && (user.persona.solicitudEmpleo.length > 0 && user.persona.solicitudEmpleo[0] != null))
  }

  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                  animation="grow" 
                  variant="primary" 
                  className={'is-absolute center-spinner-vertically'} 
                  size="lg" />
          </div>
        }
        <ToggleDetail initState={showDetail}   onToggleDetail={setShowDetail} label="Información de empleo solicitado"/>
        { 
          showDetail ? 
          <div> 
            {
              hasSolicitudEmpleo() ? <SolicitudEmpleoCard disponibilidadEntrada={disponibilidadEntrada} tipoContrato={tipoContrato} puesto={puesto} solicitudEmpleo={user.persona.solicitudEmpleo[0]}/>
              : <Form.Group as={Col} md="12">
                <span style={{fontSize: 18}}>  
                  No ha agregado información sobre el empleo solicitado
                </span>
                {/* <WarningNotiifcation message='No ha agregado información sobre el ' enphasis='empleo solicitado'/> */}
              </Form.Group>
            }
            <br/>
            <Navigation beforeUrl="/reference" continueUrl="/attachments" />
          </div>
          : 
          <div> 
            <JobAppliedInformationFormWrapper />
          </div>
        }
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
      user: state.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetLoading: (value) => dispatch(SetLoading(value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobAppliedInformationModule);
